// Copyright (c) 2023 Deere & Company

import Dealer, {getDefaultState as getDealerDefaultState} from '@deere/cps-it.warranty-model-factory/lib/dealer';

import t from 'tcomb';

const ClosingAccountSearchDealer = t.struct({

    account: Dealer,
    accountEndDate: t.maybe(t.Number),
    accountLookup: t.String,
    businessEndDate: t.maybe(t.Number),
    newAccount: Dealer,
    overrideAccount: Dealer,
    status: t.String

}, 'ClosingAccountSearchDealer');

export const getDefaultState = () =>

    new ClosingAccountSearchDealer({

        account: getDealerDefaultState(),
        accountEndDate: null,
        accountLookup: '',
        businessEndDate: null,
        newAccount: getDealerDefaultState(),
        overrideAccount: getDealerDefaultState(),
        status: ''

    });

export default ClosingAccountSearchDealer ;



// WEBPACK FOOTER //
// ./src/tcsm/wip/state/closing-account-search-account.js